<template>
  <vue3-sticky-sidebar class="sidebar" minWidth="767" containerSelector=".detail-product .container" innerWrapperSelector='.sidebar__inner' :top-spacing="110">
    <div class="detail-product__slider">
      <div v-if="isNew" class="detail-product__slider-tag-new tag-new">New</div>
      <slot name="tooltip"></slot>
      <swiper
        class="detail-product__slider--main"
        :modules="modules"
        :slides-per-view="1"
        :navigation="navMain"
        :prevent-clicks="false"
        :thumbs="{ swiper: thumbsSwiper }"
        @swiper="setSwiperRef"
      >
        <swiper-slide v-for="(item, key) in images" :key="`main-${key}`">
          <div class="swiper-slide__image" @click="openModal(key)">
            <img :src="item['400x400']" :alt="item.alt">
          </div>
        </swiper-slide>
        <div class="detail-product__slider-next">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10.003906" height="17.012207" viewBox="0 0 10.0039 17.0122" fill="none">
            <path d="M1.5 1.5L8.5 8.5L1.5 15.5" stroke="#0EA9B2" stroke-opacity="1.000000" stroke-width="3.000000" stroke-linejoin="round" stroke-linecap="round"/>
          </svg>
        </div>
        <div class="detail-product__slider-prev">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="10.005859" height="17.012207" viewBox="0 0 10.0059 17.0122" fill="none">
            <path d="M8.5 1.5L1.5 8.5L8.5 15.5" stroke="#000000" stroke-opacity="1.000000" stroke-width="3.000000" stroke-linejoin="round" stroke-linecap="round"/>
          </svg>
        </div>
      </swiper>
      <swiper
        class="detail-product__slider--thumbs"
        @swiper="setThumbsSwiper"
        :spaceBetween="10"
        slidesPerView="auto"
        :freeMode="true"
        :watchSlidesProgress="true"
        :short-swipes="false"
        :prevent-clicks="false"
        :threshold="5"
      >
        <swiper-slide v-for="item, key in images" :key="key">
          <img :src="item['image_90x90']" :alt="item.alt">
        </swiper-slide>
      </swiper>
    </div>
  </vue3-sticky-sidebar>
  <div class="detail-product__modal" :class="{'detail-product__modal_open': modalOpened}">
    <div class="detail-product__modal-close" @click="closeModal"></div>
    <div class="detail-product__modal-zoom-btns">
      <div class="detail-product__modal-zoom-btn" @click="zoomIn">+</div>
      <div class="detail-product__modal-zoom-btn" @click="zoomOut">—</div>
    </div>
    <!--Main slider-->
    <swiper
      class="detail-product__slider--main-modal"
      :modules="modalModules"
      :slides-per-view="1"
      :navigation="navModal"
      :observer="true"
      :observe-parents="true"
      :observe-slide-children="true"
      :prevent-clicks="false"
      :zoom=" {
        maxRatio: 3,
        minRatio: 1
      }"
      :thumbs="{ swiper: thumbsModalSwiper }"
      @swiper="setSwiperModalRef"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="item, key in images" :key="`modal-${key}`">
        <div class="swiper-slide__image" @click="openModal(key)">
          <div class="swiper-zoom-container">
            <img :src="item['to_jpg']" :alt="item.alt">
          </div>
        </div>
      </swiper-slide>
      <div class="detail-product__modal-next"></div>
      <div class="detail-product__modal-prev"></div>
      <div class="swiper-lazy-preloader"></div>
    </swiper>
    <swiper
      class="detail-product__slider--thumbs-modal"
      @swiper="setThumbsModalSwiper"
      :spaceBetween="10"
      slidesPerView="auto"
      :freeMode="true"
      :watchSlidesProgress="true"
      :short-swipes="false"
      :prevent-clicks="false"
      :threshold="5"
      @slideChange="onSlideChange"
    >
      <swiper-slide v-for="item, key in images" :key="key">
        <img :src="item['image_90x90']" :alt="item.alt">
      </swiper-slide>
    </swiper>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue';
import { Navigation, Pagination, Thumbs, Zoom, Lazy } from "swiper";

const modules = [Navigation, Pagination, Thumbs];
const modalModules = [Navigation, Zoom, Thumbs, Lazy];

const props = defineProps({
  isNew: {
    type: Boolean,
    default: false
  },
  images: {
    type: Array,
  },
});

const navMain = {
  nextEl: '.detail-product__slider-next',
  prevEl: '.detail-product__slider-prev',
};

let swiperRef = ref(null);

const setSwiperRef = (swiper) => {
  swiperRef.value = swiper;
};

const thumbsSwiper = ref(null);

const setThumbsSwiper = (swiper) => {
  thumbsSwiper.value = swiper;
};


const thumbsModalSwiper = ref(null);

const setThumbsModalSwiper = (swiper) => {
  thumbsModalSwiper.value = swiper;
};

const modalOpened = ref(false);

let swiperModalRef = ref(null);

const setSwiperModalRef = (swiper) => {
  swiperModalRef.value = swiper;
};

const navModal = {
  nextEl: '.detail-product__modal-next',
  prevEl: '.detail-product__modal-prev',
};



const openModal = (idx) => {
  modalOpened.value = true;
  document.body.classList.add('overflow');
  swiperModalRef.value.slideTo(idx);
  thumbsModalSwiper.value.slideTo(idx);
}

const closeModal = () => {
  swiperModalRef.value.zoom.out();
  productSlideTo();
  modalOpened.value = false;
  document.body.classList.remove('overflow');
}

const zoomIn = () => {
  swiperModalRef.value.zoom.in();
}

const zoomOut = () => {
  swiperModalRef.value.zoom.out();
}

const productSlideTo = () => {
  swiperRef.value.slideTo(swiperModalRef.value.activeIndex);
  thumbsSwiper.value.slideTo(swiperModalRef.value.activeIndex);
}

const onSlideChange = () => {
  swiperModalRef.value.zoom.out();
}

watch(() => props.images, () => {
  swiperRef.value.slideTo(0);
  thumbsSwiper.value.slideTo(0);
});
</script>
